import {
    fetchDocumentToSign, SaveSingAndData
} from "../../services/signDocument.service";
import { actionTypes } from "../contants/actionTypes";

export const getDocumentToSign = (token) => {
    console.log('token ', token);
    return (dispatch) => {
        dispatch(loadData(actionTypes.isLoadingDataSignatureDoc, true));
        fetchDocumentToSign(token)
            .then(({ data }) => {
                console.log('fetchDocumentToSign ', data);
                dispatch(loadData(actionTypes.loadDataSignatureDoc, data ?? []));
            }).catch((e) => {
                console.error('error fetchDocumentToSign', e)
            }).finally(() => {
                dispatch(loadData(actionTypes.isLoadingDataSignatureDoc, false));
            });
    }
};

export const loadData = (action, data) => ({
    type: action,
    payload: data
})

export const SaveSingnature = (obj) => {
    return (dispatch) => {
        SaveSingAndData(obj)
            .then(({ data }) => {
                console.log('fetchDocumentToSign ', data);
            }).catch((e) => {
                console.error('error fetchDocumentToSign', e)
            }).finally(() => {
            });
    }
};